export function playerRosterName(gameName: string): string {
  return gameName.trim();
}

export function formatRiotId(gameName: string, tagLine: string): string {
  return `${gameName}#${tagLine}`;
}

export function playerExternalRiotId(displayName: string, tagLine: string, gameName = ""): string {
  const name = displayName.trim() || gameName.trim();
  const tag = tagLine.trim();
  if (!name || !tag) return "";
  return formatRiotId(name, tag);
}
